import * as Lambda from '../../services/LambdaApi';
import { paginationWrapper } from '../../utils/paginationWrapper';
import { Group } from '../types/Group';

const fetchGroups = async (filter, pageNo: number = 1, pageSize: number = 100) => {
    try {
        if (!filter.Facility) throw new Error('Facility ID is required');
        const apiPath = `/s2l/${filter.Facility}/listDetailedGroups`;
        const params =
        {
            Filter: {
                ...filter
            },
            pagingSorting: {
                page_size: pageSize,
                page_no: pageNo
            }
        };

        const response = await Lambda.Post(apiPath, params, 'lambda');
        if (!response || !response.Result || !response.Result.Success || !response.Result.Content) {
            throw new Error(response.Result.Error || `Error fetching resident's interests`);
        }
        return response.Result.Content as { Result: Group[]; TotRecords: number; };
    } catch (error) {
        throw new Error("Error fetching Groups list");
    }
};

const listFacilityGroups = async ({
    filter,
    pagingSorting,
}: {
    filter: { Facility: string };
    pagingSorting: {
        page_size: number;
        page_no: number;
    };
}) => {
    if (!filter.Facility) {
        throw new Error('Facility ID is required');
    }

    const apiPath = `/s2l/${filter.Facility}/listGroups`;
    const params = {
        Filter: {
            Facility: filter.Facility,
        },
        pagingSorting,
    };
    const response = await Lambda.Post(apiPath, params, 'lambda');
    if (!response?.Result?.Content?.Result) {
        throw new Error(response?.Result?.Error || 'Error fetching groups');
    }
    return response.Result.Content as { Result: Group[]; TotRecords: number; };
};

const fetchAllFacilityGroups = async (facilityId: string) => {
    if (!facilityId) {
        throw new Error('Facility ID is required');
    }

    return paginationWrapper({
        apiCall: listFacilityGroups,
        params: {
            filter: {
                Facility: facilityId,
            },
        },
    }) as Promise<Group[]>;
};

// Same resident-scoped filter (Facility + ResidentId) the social page's GroupsPanel uses
// against fetchGroups, just paged through in full instead of incrementally.
const fetchAllResidentGroups = async (facilityId: string, residentId: string) => {
    if (!facilityId) {
        throw new Error('Facility ID is required');
    }
    if (!residentId) {
        throw new Error('Resident ID is required');
    }

    return paginationWrapper({
        apiCall: ({ filter, pagingSorting }) => fetchGroups(filter, pagingSorting.page_no, pagingSorting.page_size),
        params: {
            filter: {
                Facility: facilityId,
                ResidentId: String(residentId),
            },
        },
    }) as Promise<Group[]>;
};

export { fetchGroups, fetchAllFacilityGroups, fetchAllResidentGroups };